<section class="animation-effects donation-form-section">
  @if (!enableDonation) {
  <section class="donation-alert cmnh-callout cmnh-callout--error">
    <svg class="cmnh-callout__icon cmnh-callout__icon--error" aria-hidden="true" viewBox="0 0 24 24">
      <path d="M11 7h2v7h-2V7Zm0 9h2v2h-2v-2Z" />
      <path fill-rule="evenodd"
        d="M7.76 2h8.48L22 7.76v8.48L16.24 22H7.76L2 16.24V7.76L7.76 2Zm.83 2L4 8.59v6.82L8.59 20h6.82L20 15.41V8.59L15.41 4H8.59Z"
        clip-rule="evenodd" />
    </svg>
    <span>{{ "DONATIONS_NOT_ALLOWED" | translate }}</span>
  </section>
  }

  @if (gettingCampaign) {
  <div class="campaign-loading" aria-live="polite">
    <span class="cmnh-spinner campaign-loading-icon" aria-hidden="true"></span>
    <div class="campaign-loading-text">Getting Campaign</div>
  </div>
  }

  @if (enableDonation && !gettingCampaign) {
  <form class="donation-form" #donateForm="ngForm" (ngSubmit)="save()" #infoForm>
    @if (!drtv()) {
    <div class="campaign-banner">
      <img [src]="imageUrl" alt="" [hidden]="!imageUrl" id="campaignBannerImage" class="campaign-banner-image" />
    </div>
    }
    <app-gift-amount #giftAmount [language]="language" [gettingCampaign]="gettingCampaign"
      [donationAmounts]="donationAmounts" [transaction]="transaction" [donation]="donation" [form]="donateForm"
      [defaultDonationAmount]="defaultDonationAmount" [drtv]="drtv()" [hidden]="drtv() && transactionComplete">
    </app-gift-amount>
    <app-donor #donorForm [donorEditCommon]="donorEditCommon" [form]="donateForm" (onNameChange)="onNameChange()"
      [hidden]="drtv() && transactionComplete"></app-donor>
    <app-payment-details [transaction]="transaction" [form]="donateForm" [hidden]="drtv() && transactionComplete"
      #paymentDetailsForm></app-payment-details>
    <app-honor #honorForm [honorModel]="honorModel" [donorEditCommon]="donorEditCommon" [giftNotify]="giftNotify"
      [plannedGiving]="plannedGiving" [form]="donateForm" [hidden]="drtv()"></app-honor>
    <additional-info [hidden]="drtv()" [donorEditCommon]="donorEditCommon"
      [validationError]="additionalCommentsValidationError">
    </additional-info>
    <personal-story [hidden]="drtv()" [donorEditCommon]="donorEditCommon"
      [validationError]="personalStoryValidationError">
    </personal-story>
    <app-recaptcha-v2 #captchaRef="appRecaptcha" (resolved)="resolved($event)" (error)="errored($event)"
      [siteKey]="recaptchaSiteKey">
    </app-recaptcha-v2>
    <div class="donation-submit-section" [hidden]="drtv() && transactionComplete">
      <div class="donation-submit-action">
        <app-cmn-button class="donation-submit-wrapper" type="submit" variant="primary" size="large"
          buttonClass="donation-submit" [disabled]="isVerifying" [ariaBusy]="isVerifying" #completeGiftBtn>
          @if (isVerifying) {
          <span class="donation-submit-label">
            <span class="donation-submit-dots" aria-hidden="true">
              <span></span><span></span><span></span><span></span>
            </span>
            <span class="cmnh-visually-hidden">{{ "PLEASE_WAIT" | translate }}</span>
          </span>
          } @else {
          <span class="donation-submit-label">
            {{ "SPLASH_COMPLETE_GIFT" | translate }}
            <app-cmn-icon [name]="CmnIconName.Check"></app-cmn-icon>
          </span>
          }
        </app-cmn-button>
      </div>
      <div class="donation-submit-help">
        <div class="donation-help-text">
          <span [innerHTML]="'SPLASH_COMPLETE_GIFT_MESSAGE_BASE' | translate"></span>
          {{ " "}}
          <span [innerHTML]="'SPLASH_COMPLETE_GIFT_HELP_PHONE' | translate"></span>
          @if (csr.isCmnCampaign())
          { {{ "OR" | translate | lowercase }}
          <span [innerHTML]="'SPLASH_COMPLETE_GIFT_HELP_EMAIL' | translate"></span>
          }
        </div>
      </div>
    </div>
  </form>
  }
</section>
<app-modal [shown]="donorEditCommon.cities && donorEditCommon.cities.length > 1" [title]="'Select City'"
  (onClose)="handleCloseEditCityModal()" [onCloseText]="'CLOSE' | translate">
  <select class="cmnh-select donation-city-select" [(ngModel)]="selectedRecord" aria-label="Select City">
    <option class="cmnh-select-option" value="">
      --Select City--
    </option>

    @for (ctype of donorEditCommon.cities; track ctype) {
    <option class="cmnh-select-option" [ngValue]="ctype.recordId">
      {{ ctype.city }}
    </option>
    }
  </select>
</app-modal>

<app-modal [shown]="showVerifyAddressModal" [title]="'VERIFY_ADDRESS' | translate"
  (onClose)="handleCloseVerifyAddressModal('')" [onCloseText]="'RETRY' | translate"
  (onContinue)="handleCloseVerifyAddressModal('ignore')" [onContinueText]="'IGNORE' | translate"
  (onAccept)="handleCloseVerifyAddressModal('accept')" [onAcceptText]="
    (donorEditCommon.melissaData.address1 ? 'ACCEPT' : '') | translate
  ">
  <h3 class="donation-address-message" [hidden]="donorEditCommon.melissaData.address1">
    {{ "MELISSA_GENERIC_ERROR_2" | translate }}
  </h3>
  <div [hidden]="!donorEditCommon.melissaData.address1">
    <table class="donation-address-table">
      <tbody>
        <tr>
          <td>&nbsp;</td>
          <td>
            {{ "BEFORE" | translate }}
          </td>
          <td>{{ "AFTER" | translate }} (USPS)</td>
        </tr>
        <tr [class.differentAddressElement]="
            rowClass(
              donorEditCommon.donor.address1,
              donorEditCommon.melissaData.address1
            ) === 'differentAddressElement'
          ">
          <td>{{ "ADDRESS_1" | translate }}</td>
          <td>
            {{ donorEditCommon.donor.address1 }}
          </td>
          <td>
            {{ donorEditCommon.melissaData.address1 }}
          </td>
        </tr>
        <tr [class.differentAddressElement]="
            rowClass(
              donorEditCommon.donor.address2,
              donorEditCommon.melissaData.address2
            ) === 'differentAddressElement'
          ">
          <td>
            {{ "ADDRESS_2" | translate }}
          </td>
          <td>
            {{ donorEditCommon.donor.address2 }}
          </td>
          <td>
            {{ donorEditCommon.melissaData.address2 }}
          </td>
        </tr>
        <tr [class.differentAddressElement]="
            rowClass(
              donorEditCommon.donor.city,
              donorEditCommon.melissaData.city
            ) === 'differentAddressElement'
          ">
          <td>
            {{ "CITY" | translate }}
          </td>
          <td>
            {{ donorEditCommon.donor.city }}
          </td>
          <td>
            {{ donorEditCommon.melissaData.city }}
          </td>
        </tr>
        <tr [class.differentAddressElement]="
            rowClass(
              donorEditCommon.donor.state,
              donorEditCommon.melissaData.state
            ) === 'differentAddressElement'
          ">
          <td>
            {{ "STATE" | translate }}
          </td>
          <td>
            {{ donorEditCommon.donor.state }}
          </td>
          <td>
            {{ donorEditCommon.melissaData.state }}
          </td>
        </tr>
        <tr [class.differentAddressElement]="
            rowClass(
              donorEditCommon.donor.postalCode,
              donorEditCommon.melissaData.postalCode
            ) === 'differentAddressElement'
          ">
          <td>
            {{ "POSTAL_CODE" | translate }}
          </td>
          <td>
            {{ donorEditCommon.donor.postalCode }}
          </td>
          <td>
            {{ donorEditCommon.melissaData.postalCode }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</app-modal>

<app-modal [shown]="showVerifyModal" [title]="'VERIFY_TITLE' | translate" (onClose)="handleCloseVerifyModal(false)"
  [onCloseText]="'REENTER_INFORMATION' | translate" (onSuccess)="handleCloseVerifyModal(true)"
  [onSuccessText]="'CONTINUE' | translate">
  <form #verifyCCForm="ngForm">
    <div class="donation-summary donation-summary-grid">
      @if (showVerifyCCModal) {
      <div class="donation-summary-column">
        <div class="donation-summary-field">
          <strong>{{ "CREDIT_CARD_NO" | translate }}</strong>
          <div class="donation-summary-value">
            <span>
              {{ wf1MaskAccount(transaction.creditCard) }}
            </span>
          </div>
        </div>
        <div class="donation-summary-field">
          <strong>{{ "CC_TYPE" | translate }}</strong>
          <div class="donation-summary-value">
            {{ typeOut }}
          </div>
        </div>
        <div class="donation-summary-field">
          <strong>{{ "EXPIRATION_DATE" | translate }}</strong>
          <div class="donation-summary-value">
            {{ transaction.expirationMonth }} / {{ transaction.expirationYear }}
          </div>
        </div>
      </div>
      }
      <div class="donation-summary-column">
        @if (transaction.venmoUserName) {
        <div class="donation-summary-field">
          <strong>{{ "ACCOUNT" | translate }}</strong>
          <div class="donation-summary-value">
            {{ accountDisplayName }}
          </div>
        </div>
        }
        <div class="donation-summary-field">
          <strong>{{ "DONATION_FREQUENCY" | translate }}</strong>
          <div class="donation-summary-value">
            {{ frequency }}
          </div>
        </div>
        <div class="donation-summary-field">
          <strong>{{ "AMOUNT" | translate }}</strong>
          <div class="donation-summary-value">
            <strong>
              {{ transaction.donationAmount | currency }}
            </strong>
          </div>
        </div>
      </div>
    </div>
  </form>
</app-modal>

<app-modal [shown]="showConfirmCreditCardECheckPaymentModal" [title]="'PAYMENT_CONFIRMATION_TITLE' | translate"
  (onClose)="handleCloseCreditCardECheckPaymentModal()" [onCloseText]="'CLOSE' | translate" size="md">
  <form #confirmCreditCardECheckPaymentModal="ngForm">
    <div class="donation-confirmation-message">
      <p>{{ "PAYMENT_CONFIRMATION_MSG1" | translate }}</p>
      <p>{{ "PAYMENT_CONFIRMATION_MSG2" | translate }}</p>
    </div>

    <div class="donation-summary">
      <div class="donation-summary-column">
        <div class="donation-summary-field">
          @if (drtv()) {
          <p>
            Thank you for your generous support today.
            {{
            donorEditCommon.donor.cmnhHospitalName ||
            "Your local children's hospital"
            }}
            will now be able to count on your gift to help kids in your
            community get access to the care they need.
          </p>
          }
          <strong>{{ "DONATION_FREQUENCY" | translate }}</strong>
          <div class="donation-summary-value">
            {{ frequency }}
          </div>
        </div>
        <div class="donation-summary-field">
          <strong>{{ "AMOUNT" | translate }}</strong>
          <div class="donation-summary-value">
            <strong>
              {{ csr.donationAmount | currency }}
            </strong>
          </div>
        </div>
      </div>
      <div class="donation-summary-column">
        @if (transaction.venmoUserName) {
        <div class="donation-summary-field">
          <strong>{{ "ACCOUNT" | translate }}</strong>
          <div class="donation-summary-value">
            {{ accountDisplayName }}
          </div>
        </div>
        }
        <div class="donation-summary-field">
          <strong>{{ "YOUR_REFERENCENO" | translate }}</strong>
          <div class="donation-summary-value">
            {{ csr.authCode }}
          </div>
        </div>
      </div>
      <div class="donation-summary-note">
        <i>{{ "PAYMENT_CONFIRMATION_STATEMENT" | translate }}</i>
      </div>
      <div class="donation-follow-up-action" [hidden]="!drtv()">
        If you want to make another donation, please click
        <a class="donation-link" (click)="continueWithCall(true)">Here</a> or reload the page.
      </div>
    </div>
  </form>
</app-modal>

<app-modal [shown]="showFailedCCECheckModal" [title]="'FAILED_TRANSACTION_PAGE_TITLE' | translate"
  (onClose)="handleCloseFailedCCECheckModal()" [onCloseText]="'CLOSE' | translate">
  <form #failedCCECheckModal="ngForm">
    <div class="donation-summary">
      <div class="donation-summary-column">
        <div class="donation-summary-field">
          <strong>{{ "RESPONSE" | translate }}</strong>
          <div class="donation-summary-value">
            {{ csr.responseMsg }}
          </div>
        </div>
      </div>
    </div>
  </form>
</app-modal>

<app-modal [shown]="showVerifyeCheckPaymentModal" [title]="'VERIFY_ECHECK_TITLE' | translate"
  (onClose)="handleCloseVerifyeCheckPaymentModal()" [onCloseText]="'REENTER_INFORMATION' | translate"
  (onSuccess)="handleCloseVerifyeCheckPaymentModal(true)" [onSuccessText]="'CONTINUE' | translate">
  <form #verifyECheckForm="ngForm" class="donation-modal-form">
    <div class="donation-summary donation-summary-grid">
      <div class="donation-summary-column">
        <div class="donation-summary-field">
          <strong>{{ "ACCOUNT" | translate }}</strong>
          <div class="donation-summary-value">
            {{ transaction.abaNumber }} /
            <span>{{ wf1MaskAccount(transaction.bankAccountNumber) }}</span>
          </div>
        </div>
        <div class="donation-summary-field">
          <strong>{{ "BANK_NAME" | translate }}</strong>
          <div class="donation-summary-value">
            {{ transaction.bankName }}
          </div>
        </div>
        <div class="donation-summary-field">
          <strong>{{ "ACCOUNT_TYPE" | translate }}</strong>
          <div class="donation-summary-value">
            {{ (transaction.isCheckingAccount ? "CHECKING" : "SAVINGS") | translate }}
          </div>
        </div>
      </div>
      <div class="donation-summary-column">
        <div class="donation-summary-field">
          <strong>{{ "DONATION_FREQUENCY" | translate }}</strong>
          <div class="donation-summary-value">
            {{ frequency }}
          </div>
        </div>
        <div class="donation-summary-field">
          <strong>{{ "AMOUNT" | translate }}</strong>
          <div class="donation-summary-value">
            <strong>
              {{ transaction.donationAmount | currency }}
            </strong>
          </div>
        </div>
      </div>
    </div>
    @if ("ECHECK_MANDATE" | translate) {
    <div>
      <p>{{ "ECHECK_MANDATE" | translate }}</p>
    </div>
    }
  </form>
</app-modal>
